import { ref } from 'vue'
import { defineStore } from 'pinia'

import type { PostUsersDTO } from '~/core/types/users'

export const useRegisterStore = defineStore('auth/register', () => {
  const payload = ref<PostUsersDTO>({
    phone: '',
    email: '',
    first_name: '',
    last_name: '',
    password: '',
    password_confirmation: '',
  })

  return {
    payload,
  }
})
